exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slick-dots{display:flex!important;justify-content:center;flex-wrap:wrap;align-items:center;min-height:50px;padding-left:60px;padding-right:60px}", ""]);

// exports
